export const calculateInstallmentWithInterest = (
  installmentMaxQuantity: number,
  installmentMaxQuantityWithoutInterest: number,
  installmentPriceWithInterest: number
): number => {
  const isInterestFreeInstallment =
    installmentMaxQuantity === installmentMaxQuantityWithoutInterest
  if (isInterestFreeInstallment) return 0
  return installmentPriceWithInterest / installmentMaxQuantity
}
